export class BundlePickerFooter extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['footer']
  }

  connectedCallback () {
    if (this.hasBeenInitialised) return

    super.connectedCallback()

    this.updatePosition()
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.resizeObserver?.disconnect()
    this.intersectionObserver?.disconnect()
  }

  setupListeners () {
    this.footer = this.els.footer.element

    this.onIntersect = this.onIntersect.bind(this)
    this.updatePosition = this.updatePosition.bind(this)

    this.resizeObserver = new ResizeObserver(this.updatePosition)
    this.resizeObserver.observe(this.footer)

    this.listeners.add(window, 'resize', this.updatePosition, { passive: true })
  }

  /**
   * @returns {void}
   */
  updatePosition () {
    this.intersectionObserver?.disconnect()

    if (window.BAO.MediaBreakpoints.isMd) {
      this.removeAttribute('data-sticky-state')
      this.style.removeProperty('--BundlePickerFooter_Height')

      return
    }

    const height = this.footer.offsetHeight

    this.style.setProperty('--BundlePickerFooter_Height', `${height}px`)
    this.setAttribute('data-sticky-state', 'floating')

    this.intersectionObserver = new IntersectionObserver(this.onIntersect, {
      rootMargin: `0px 0px -${height}px 0px`,
      threshold: 0,
    })

    this.intersectionObserver.observe(this)
  }

  /**
   * @param {IntersectionObserverEntry[]} entries
   *
   * @returns {void}
   */
  onIntersect (entries) {
    const entry = entries[entries.length - 1]
    const dockingLine =
      entry.rootBounds?.bottom ?? window.innerHeight - this.footer.offsetHeight

    this.setAttribute(
      'data-sticky-state',
      entry.boundingClientRect.top <= dockingLine ? 'docked' : 'floating',
    )
  }
}

if (!customElements.get('bundle-picker-footer')) {
  customElements.define('bundle-picker-footer', BundlePickerFooter)
}
